import {IStateService} from 'angular-ui-router';
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import {TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';
import TSEigenleistung from '../../../models/TSEigenleistung';
import TSEigenleistungDaten from '../../../models/TSEigenleistungDaten';
import TSSchadenfall from '../../../models/TSSchadenfall';
import DVBernUtil from '../../../utils/DVBernUtil';
import {IEigenleistungeStateParams} from '../../gesuch.route';
import AbstractModelManagerController from '../abstractModelManagerController';

declare let require: any;
declare let angular: any;

import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let styles = require('./eigenleistungView.scss');
let template = require('./eigenleistungView.html');

export class EigenleistungEditViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = EigenleistungViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        eigenleistung: '<',
        schadenfallId: '<',
        schaetzung: '<',
        // saveDisabled: '=',
    };
}

export class EigenleistungViewController extends AbstractModelManagerController<TSEigenleistung> {

    eigenleistung: TSEigenleistung;
    form: IFormController;
    schadenfallId: string;
    readonly: boolean;
    schadenfallStatus: TSSchadenfallStatus;
    schadenfall: TSSchadenfall;
    saveDisabled: boolean;
    schaetzung: boolean;

    static $inject = ['DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$translate', '$log', '$state'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil, schadenfallModelManager: SchadenfallModelManager,
                private $q: IQService,
                $scope: IScope, private $translate: ITranslateService, private $log: ILogService,
                private $state: IStateService, private $stateParams: IEigenleistungeStateParams,
    ) {
        super(schadenfallModelManager, $scope, $state.current.name);
    }

    $onInit() {
        super.$onInit();
        if (!this.eigenleistung) {
            this.eigenleistung = new TSEigenleistung();
            this.eigenleistung.schaetzung = this.schaetzung;
            this.eigenleistung.eigenleistungDatenFS = new TSEigenleistungDaten();
            this.eigenleistung.eigenleistungStundenDaten = [];
            this.$log.warn('initialized eigenleistung to edit directly in view, should pass eigenleistung to edit along');
        } else {
            this.initialModel = this.eigenleistung;
            this.model = angular.copy(this.eigenleistung);
        }
        this.readonly = this.schadenfallModelManager.isSchadenReadonly('eigenleistungen');

        let schadenfall = this.schadenfallModelManager.getSchadenfall();
        if (schadenfall) {
            this.schadenfallStatus = schadenfall.status;
            this.schadenfall = schadenfall;
        }

        this.saveDisabled = false;
    }

    public saveEigenleistungen() {
        if (this.isModelValid() && this.eigenleistung) {
            this.schadenfallModelManager.saveEigenleistungen(this.getModel()).then((result: any) => {
                this.navigateAway();
            });
        } else {
            this.$log.debug('Form was not valid');
        }

    }

    public cancelEigenleistungen() {
        this.model = angular.copy(this.initialModel);
        this.form.$setPristine();
        this.navigateAway();
    }

    private navigateAway() {
        const nextPage = this.schaetzung ? 'schaetzung' : 'aufwaende';
        this.$state.go(nextPage, {schadenfallId: this.schadenfallId});
    }

}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/eigenleistungView/eigenleistungView.ts